var map = {
	"./general/DocsIcon--bluecheckmark.svg": 2310,
	"./general/DocsIcon--country.svg": 2311,
	"./general/DocsIcon--github.svg": 2312,
	"./general/DocsIcon--guide.svg": 2313,
	"./general/DocsIcon--list.svg": 2314,
	"./general/DocsIcon--locale.svg": 2315,
	"./general/DocsIcon--thumbsdown.svg": 2316,
	"./general/DocsIcon--thumbsup.svg": 2317,
	"./general/DocsIcon--video.svg": 2318,
	"./nav/DocsIcon--account.svg": 2319,
	"./nav/DocsIcon--business.svg": 2320,
	"./nav/DocsIcon--developertools.svg": 2321,
	"./nav/DocsIcon--financialservices.svg": 2322,
	"./nav/DocsIcon--home.svg": 2323,
	"./nav/DocsIcon--mobilenav.svg": 2324,
	"./nav/DocsIcon--payments.svg": 2325,
	"./nav/DocsIcon--reference.svg": 2326,
	"./nav/DocsIcon--security.svg": 2327,
	"./product/DocsIcon--account.svg": 2328,
	"./product/DocsIcon--atlas.svg": 2329,
	"./product/DocsIcon--capital.svg": 2330,
	"./product/DocsIcon--checkout.svg": 2331,
	"./product/DocsIcon--climate.svg": 2332,
	"./product/DocsIcon--connect.svg": 2333,
	"./product/DocsIcon--corporatecard.svg": 2334,
	"./product/DocsIcon--dashboard.svg": 2335,
	"./product/DocsIcon--developertools.svg": 2336,
	"./product/DocsIcon--elements.svg": 2337,
	"./product/DocsIcon--gateddocs.svg": 2338,
	"./product/DocsIcon--identity.svg": 2339,
	"./product/DocsIcon--implementationguides.svg": 2340,
	"./product/DocsIcon--invoicing.svg": 2341,
	"./product/DocsIcon--issuing.svg": 2342,
	"./product/DocsIcon--partners.svg": 2343,
	"./product/DocsIcon--payments.svg": 2344,
	"./product/DocsIcon--radar.svg": 2345,
	"./product/DocsIcon--reporting.svg": 2346,
	"./product/DocsIcon--sigma.svg": 2347,
	"./product/DocsIcon--styleguide.svg": 2348,
	"./product/DocsIcon--tax.svg": 2349,
	"./product/DocsIcon--terminal.svg": 2350,
	"./product/DocsIcon--treasury.svg": 2351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2309;